import { motion } from "framer-motion";
import {
  Home,
  Hammer,
  Droplet,
  Layers,
  WavesLadder,
  Building2,
  HomeIcon,
  PanelsTopLeft,
  Trees,
  Users,
} from "lucide-react";

export default function Roadmap() {
  const steps = [
    {
      icon: <Home size={18} />,
      title: "Land Acquisition",
      date: "Q1 2025",
      desc: "Securing land and permits for development.",
    },
    {
      icon: <Droplet size={18} />,
      title: "Planning & Drainage",
      date: "Q2 2025",
      desc: "Infrastructure and drainage setup.",
    },
    {
      icon: <Hammer size={18} />,
      title: "Foundation Work",
      date: "Q3 2025",
      desc: "Villa bases, pools, and reservoirs built.",
    },
    {
      icon: <Layers size={18} />,
      title: "Base Layer",
      date: "Q4 2025",
      desc: "Ground structures and reinforcements.",
    },
    {
      icon: <WavesLadder size={18} />,
      title: "First Floor",
      date: "Q1 2026",
      desc: "Floors, stairs, and ceilings raised.",
    },
    {
      icon: <Building2 size={18} />,
      title: "Second Floor",
      date: "Q2 2026",
      desc: "Upper-level structures completed.",
    },
    {
      icon: <HomeIcon size={18} />,
      title: "Roof Construction",
      date: "Q3 2026",
      desc: "Roofs finalized for all villas.",
    },
    {
      icon: <PanelsTopLeft size={18} />,
      title: "Facade & Windows",
      date: "Q4 2026",
      desc: "Exterior finishes and windows installed.",
    },
    {
      icon: <Trees size={18} />,
      title: "Exterior Finishing",
      date: "Q1 2027",
      desc: "Landscaping and outdoor areas completed.",
    },
    {
      icon: <Users size={18} />,
      title: "Public Areas",
      date: "Q2 2027",
      desc: "Community parks, roads, and amenities delivered.",
    },
  ];

  return (
    <section id="roadmap">
      <h2>Construction Roadmap</h2>
      <div className="timeline">
        <div className="timeline-line"></div>

        {steps.map((s, i) => (
          <motion.div
            key={i}
            className={`timeline-row ${i % 2 === 0 ? "left" : "right"}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6 }}
          >
            {/* Left text */}
            {i % 2 === 0 && (
              <div className="timeline-text text-right">
                <span className="timeline-date">{s.date}</span>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            )}

            {/* Icon in the center line */}
            <div className="timeline-icon">{s.icon}</div>

            {/* Right text */}
            {i % 2 !== 0 && (
              <div className="timeline-text text-left">
                <span className="timeline-date">{s.date}</span>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            )}
          </motion.div>
        ))}
      </div>
    </section>
  );
}
